var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgentina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5H22V16.5H0V11.5ZM0 0.5H22V5.5H0V0.5Z",
    fill: "#3ECBF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M10.9999 10.1004C11.8678 10.1004 12.5713 9.38405 12.5713 8.50039C12.5713 7.61673 11.8678 6.90039 10.9999 6.90039C10.132 6.90039 9.42847 7.61673 9.42847 8.50039C9.42847 9.38405 10.132 10.1004 10.9999 10.1004Z",
    fill: "#FFDA2C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_2313"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentina);
export default __webpack_public_path__ + "static/media/argentina.5d89968f3abb908896bb926c23528f86.svg";
export { ForwardRef as ReactComponent };